import React from "react";

import { Input, Radio, Row, Col, Collapse, Typography } from "antd";
import CustomCard from "./CustomCard";

const { Panel } = Collapse;
const { Paragraph } = Typography;
export default function AIConfiguration({
	tone,
	setTone,
	maxWords,
	setMaxWords,
	targetAudience,
	setTargetAudience,
	productType,
	setProductType,
	ctaType,
	setCtaType,
}) {
	return (
		<CustomCard>
			<Row gutter={[16, 16]}>
				<Col span={12}>
					<Paragraph>Tone:</Paragraph>
					<Radio.Group
						options={["Professional", "Casual", "Luxury", "Fun", "Minimal"]}
						value={tone}
						onChange={(e) => setTone(e.target.value)}
					/>
				</Col>
				<Col span={12}>
					<Paragraph>Max Words:</Paragraph>
					<Input
						type="number"
						value={maxWords}
						onChange={(e) => setMaxWords(Number(e.target.value))}
					/>
				</Col>
				<Col span={24}>
					<Paragraph>Target Audience:</Paragraph>
					<Input
						value={targetAudience}
						onChange={(e) => setTargetAudience(e.target.value)}
						placeholder="e.g., tech enthusiasts, budget shoppers"
					/>
				</Col>
				<Col span={12}>
					<Paragraph>Product Type:</Paragraph>
					<Radio.Group
						options={["Electronics", "Fashion", "Beauty", "Fitness", "Other"]}
						value={productType}
						onChange={(e) => setProductType(e.target.value)}
					/>
				</Col>
				<Col span={12}>
					<Paragraph>Call to Action Style:</Paragraph>
					<Radio.Group
						options={["Urgency", "Exclusivity", "Discount-based"]}
						value={ctaType}
						onChange={(e) => setCtaType(e.target.value)}
					/>
				</Col>
			</Row>
		</CustomCard>
	);
}
